import config from '@config';
import {
  initializeHttp,
  setupCookieUnauthorizedInterceptorFabric,
  setupCsrfInterceptor,
  setupRequestInterceptor,
  setupServerErrorInterceptor,
} from '@gasbi/shared';

// No organization session here (GSB-8539): the organizationId header names the organization of every request.
const instance = initializeHttp(config.VITE_API_URL, [
  setupRequestInterceptor,
  setupCsrfInterceptor,
  setupCookieUnauthorizedInterceptorFabric('/api/login'),
  setupServerErrorInterceptor,
]);

export default instance;
